import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { LiveDocsIconTileProps } from '../src/icons/LiveDocsIconTile.tsx';

export const LiveDocsIconTile: LoadableType<LiveDocsIconTileProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LiveDocsIconTile" */
				'../src/icons/LiveDocsIconTile.tsx'
			)
		).LiveDocsIconTile,
});
